/**
 * Client-side session helpers for cookie-only JWT auth.
 * Tokens live in HttpOnly cookies only — never in localStorage or Redux.
 */

const SESSION_KEYS = [
  "isAuthenticated",
  "lastVisitedPath",
  "accessToken",
  "refreshToken",
];

export function setSessionAuthenticated() {
  localStorage.setItem("isAuthenticated", "true");
}

export function clearClientSession() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function purgePersistedJwtFields() {
  try {
    const root = localStorage.getItem("persist:root");
    if (!root) return;

    const parsed = JSON.parse(root);
    if (!parsed.auth) return;

    const auth = JSON.parse(parsed.auth);
    if (!("accessToken" in auth) && !("refreshToken" in auth)) return;

    delete auth.accessToken;
    delete auth.refreshToken;
    parsed.auth = JSON.stringify(auth);
    localStorage.setItem("persist:root", JSON.stringify(parsed));
  } catch {
    // localStorage may be unavailable or corrupt
  }
}
